/**
* @name: common-left-menu-list
* @author: weiyong
* @date: 2024-10-06 19:28
* @description：common-left-menu-list
* @update: 2024-10-06 19:28
*/
<template>
  <div :class="prefixCls" class="h100b">
<!--    <div class="sceneApp main-menu-bar show flex-div">-->
<!--      <div class="topImg">-->
<!--        <span class="remix-icon ri-dashboard-line2"></span>-->
<!--      </div>-->
<!--      <div class="sceneApp_name">常用菜单</div>-->
<!--    </div>-->

    <template v-for="item in menuList">
      <div @click="selActiveOneMenu(item)"
           :class="activeMenuId===item.id?'active-menu':'not-active-menu'"
           class="sceneApp show flex-div">
        <div class="topImg">
          <span :class="item.source||'remix-icon ri-erweima'"></span>
        </div>
        <div class="sceneApp_name">{{ item.name }}</div>
      </div>

    </template>


  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "common-left-menu-list",
});
</script>

<script lang="ts" setup>
import {useDesign} from "@/hooks/web/useDesign";
import {useUserRecentMenu} from "@/layouts/layoutFrame/military/hooks/useUserRecentMenu";

const {prefixCls} = useDesign('common-left-menu-list');

const {menuList,selActiveOneMenu,activeMenuId}=useUserRecentMenu();
</script>

<style type="text/css" lang="less">

@prefix-cls: ~'@{namespace}-common-left-menu-list';

.@{prefix-cls} {
  background-color: var(--bgColor,#EEF2FE);
  border-right: 1px solid #dfdfdf;
  background-repeat: repeat;
  background-size: 100% 100%;

  .main-menu-bar{
    background-color: var(--bgColor, rgba(238, 34, 51, .1));
    &:hover{
      background-color: var(--bgColor, rgba(238, 34, 51, .5));
    }
  }
  .topImg{
    padding-right: 12px;
    padding-left: 4px;
    display: inline-block;
    .remix-icon{
      font-size:20px;
    }
  }
  .sceneApp{
    width:200px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: start;
    padding:10px 12px;
    &.active-menu{
      background-color: #D3E2FD;
      color:#333 !important;
    }
    &:hover{
      background-color: #D3E2FD;
      color:var(--primary-color,#0a6eff);
    }
  }
  .sceneApp_name{
    font-size: 14px;
  }
}
</style>
